import React from 'react';
import { motion } from 'framer-motion';

interface VerticalStepperProps {
  currentStep: number;
  totalSteps?: number;
}

const steps = [
  { label: 'Dati Personali' },
  { label: 'Info Professionali' },
  { label: 'Materie e Scuole' },
  { label: 'Disponibilità' },
  { label: 'Riepilogo' },
];

const VerticalStepper: React.FC<VerticalStepperProps> = ({ currentStep }) => {
  return (
    <>
      {/* Desktop: Vertical */}
      <nav className="hidden md:flex flex-col gap-0" aria-label="Progress">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={step.label} className="flex items-start">
              <div className="flex flex-col items-center">
                {/* Dot */}
                <motion.div
                  initial={false}
                  animate={{
                    scale: isCurrent ? 1.1 : 1,
                    backgroundColor: isCompleted || isCurrent ? '#C8102E' : '#D1D5DB',
                  }}
                  className={`w-4 h-4 rounded-full flex items-center justify-center ${
                    isCurrent ? 'ring-4 ring-fpcred/30' : ''
                  }`}
                >
                  {isCompleted && (
                    <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </motion.div>

                {/* Vertical Line */}
                {index < steps.length - 1 && (
                  <div
                    className={`w-0.5 h-8 ${
                      stepNumber < currentStep ? 'bg-fpcred' : 'bg-gray-300'
                    }`}
                  />
                )}
              </div>

              {/* Label */}
              <span
                className={`ml-3 text-sm font-medium ${
                  isCurrent ? 'text-fpcred' : isCompleted ? 'text-gray-700' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </nav>

      {/* Mobile: Horizontal */}
      <nav className="flex md:hidden justify-center gap-2" aria-label="Progress">
        {steps.map((_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <motion.div
              key={index}
              initial={false}
              animate={{
                scale: isCurrent ? 1.2 : 1,
                backgroundColor: isCompleted || isCurrent ? '#C8102E' : '#D1D5DB',
              }}
              className={`w-3 h-3 rounded-full ${isCurrent ? 'ring-2 ring-fpcred/30' : ''}`}
            >
              {isCompleted && (
                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </motion.div>
          );
        })}
      </nav>
    </>
  );
};

export default VerticalStepper;
